import { React, useState, useEffect, useContext } from 'react'
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant"
import { AuthContext } from '../../../component/context/AuthContext';
import { Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datetime';
import moment from 'moment';
import Swal from 'sweetalert2';
import { FiDownload, FiCheckCircle } from 'react-icons/fi';

function AssetRegister() {
    const [authUserData] = useContext(AuthContext);
    const [fullLoading, setFullLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [action, setAction] = useState('Add');
    const [disabled, setDisabled] = useState('');

    // Return modal
    const [showReturn, setShowReturn] = useState(false);
    const [returnAssetId, setReturnAssetId] = useState('');
    const [returnCondition, setReturnCondition] = useState('good');
    const [returnNotes, setReturnNotes] = useState('');

    // Maintenance modal
    const [showMaint, setShowMaint] = useState(false);
    const [maintAssetId, setMaintAssetId] = useState('');
    const [maintType, setMaintType] = useState('repair');
    const [maintDesc, setMaintDesc] = useState('');
    const [maintCost, setMaintCost] = useState('');
    const [maintVendor, setMaintVendor] = useState('');
    const [maintStartDate, setMaintStartDate] = useState('');

    // Form
    const [itemId, setItemId] = useState('');
    const [assetTag, setAssetTag] = useState('');
    const [assetTypeId, setAssetTypeId] = useState('');
    const [brandId, setBrandId] = useState('');
    const [modelName, setModelName] = useState('');
    const [serialNumber, setSerialNumber] = useState('');
    const [purchaseDate, setPurchaseDate] = useState('');
    const [purchaseCost, setPurchaseCost] = useState('');
    const [warrantyEndDate, setWarrantyEndDate] = useState('');
    const [condition, setCondition] = useState('new');
    const [location, setLocation] = useState('');
    const [classification, setClassification] = useState('general');
    const [notes, setNotes] = useState('');

    // Dropdowns
    const [assetTypes, setAssetTypes] = useState([]);
    const [brands, setBrands] = useState([]);

    // Search
    const [srchTag, setSrchTag] = useState('');
    const [srchType, setSrchType] = useState('');
    const [srchBrand, setSrchBrand] = useState('');
    const [srchModel, setSrchModel] = useState('');
    const [srchSerial, setSrchSerial] = useState('');
    const [srchStatus, setSrchStatus] = useState('');
    const [srchCondition, setSrchCondition] = useState('');
    const [srchHolder, setSrchHolder] = useState('');

    // Pagination
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(20);
    const [activePage, setActivePage] = useState(1);
    const [maxPageLimit, setMaxPageLimit] = useState(20);
    const [minPageLimit, setMinPageLimit] = useState(0);
    const [dataSort, setDataSort] = useState({ order: 'desc', order_by: 'id' });
    const [searchParam, setSearchParam] = useState({});

    // Selected for bulk verify
    const [selectedRows, setSelectedRows] = useState([]);

    let isToken = '';
    let userId = '';
    if (authUserData && authUserData[0]) {
        isToken = authUserData[0].token || '';
        userId = authUserData[0].user_id || '';
    }

    useEffect(() => {
        if (isToken) { fetchData(); fetchAssetTypes(); fetchBrands(); }
    }, [searchParam, dataSort, activePage, perPage, isToken]);

    async function fetchData() {
        setLoading(true);
        try {
            const res = await axios.post(CONST.ASSET_ITEM_LIST, {
                limit: perPage, page_number: activePage, search_input: searchParam, sort: dataSort,
            }, { headers: { Authorization: `Bearer ${isToken}` } });
            if (res.data.status === 'success') {
                setData(res.data.data || []);
                setTotalRows(res.data.count || 0);
            } else { setData([]); setTotalRows(0); }
        } catch (e) { setData([]); setTotalRows(0); }
        setLoading(false);
    }

    async function fetchAssetTypes() {
        try {
            const res = await axios.get(CONST.GET_ACTIVE_ASSET_TYPE_LIST, { headers: { Authorization: `Bearer ${isToken}` } });
            if (res.data.status === 'success') setAssetTypes(res.data.data || []);
        } catch (e) {}
    }

    async function fetchBrands() {
        try {
            const res = await axios.get(CONST.GET_ACTIVE_BRAND_LIST, { headers: { Authorization: `Bearer ${isToken}` } });
            if (res.data.status === 'success') setBrands(res.data.data || []);
        } catch (e) {}
    }

    const handleShow = async (act, row) => {
        setAction(act);
        if (act === 'Edit' && row) {
            try {
                const res = await axios.get(CONST.GET_ASSET_ITEM + row.id, { headers: { Authorization: `Bearer ${isToken}` } });
                if (res.data.status === 'success') {
                    const d = res.data.data;
                    setItemId(d.id); setAssetTag(d.asset_tag); setAssetTypeId(d.asset_type_id);
                    setBrandId(d.brand_id || ''); setModelName(d.model_name || '');
                    setSerialNumber(d.serial_number || ''); setPurchaseDate(d.purchase_date || '');
                    setPurchaseCost(d.purchase_cost || ''); setWarrantyEndDate(d.warranty_end_date || '');
                    setCondition(d.condition || 'new'); setLocation(d.location || '');
                    setClassification(d.classification || 'general'); setNotes(d.notes || '');
                }
            } catch (e) {}
        } else {
            // Get next tag
            if (assetTypeId) {
                try {
                    const res = await axios.get(CONST.GET_NEXT_ASSET_TAG + (assetTypeId || 1), { headers: { Authorization: `Bearer ${isToken}` } });
                    if (res.data.status === 'success') setAssetTag(res.data.data.tag);
                } catch (e) {}
            }
        }
        setShow(true);
    };

    const handleClose = () => {
        setShow(false); setItemId(''); setAssetTag(''); setAssetTypeId(''); setBrandId('');
        setModelName(''); setSerialNumber(''); setPurchaseDate(''); setPurchaseCost('');
        setWarrantyEndDate(''); setCondition('new'); setLocation(''); setClassification('general'); setNotes('');
    };

    // Auto-fetch tag when asset type changes
    const handleTypeChange = async (typeId) => {
        setAssetTypeId(typeId);
        if (action === 'Add' && typeId) {
            try {
                const res = await axios.get(CONST.GET_NEXT_ASSET_TAG + typeId, { headers: { Authorization: `Bearer ${isToken}` } });
                if (res.data.status === 'success') setAssetTag(res.data.data.tag);
            } catch (e) {}
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!assetTypeId) { toast.error("Asset Type is required."); return; }
        setDisabled('disabled');
        try {
            const payload = {
                asset_type_id: assetTypeId, brand_id: brandId || null, model_name: modelName,
                serial_number: serialNumber, purchase_date: purchaseDate ? moment(purchaseDate).format('YYYY-MM-DD') : null,
                purchase_cost: purchaseCost || null, warranty_end_date: warrantyEndDate ? moment(warrantyEndDate).format('YYYY-MM-DD') : null,
                condition, location, classification, notes, user_id: userId,
            };
            let res;
            if (action === 'Add') {
                res = await axios.post(CONST.ADD_ASSET_ITEM, payload, { headers: { Authorization: `Bearer ${isToken}` } });
            } else {
                res = await axios.put(CONST.UPDATE_ASSET_ITEM + itemId, { ...payload, id: itemId }, { headers: { Authorization: `Bearer ${isToken}` } });
            }
            if (res.data.status === 'success') { toast.success(res.data.message); handleClose(); fetchData(); }
            else toast.error(res.data.message);
        } catch (e) { toast.error("Something went wrong."); }
        setDisabled('');
    };

    const handleReturn = async () => {
        if (!returnAssetId) return;
        setDisabled('disabled');
        try {
            const res = await axios.post(CONST.RETURN_ASSET, {
                asset_item_id: returnAssetId, user_id: userId, condition: returnCondition, notes: returnNotes
            }, { headers: { Authorization: `Bearer ${isToken}` } });
            if (res.data.status === 'success') { toast.success(res.data.message); setShowReturn(false); setReturnNotes(''); fetchData(); }
            else toast.error(res.data.message);
        } catch (e) { toast.error("Something went wrong."); }
        setDisabled('');
    };

    const handleMaintSubmit = async () => {
        if (!maintAssetId || !maintDesc) { toast.error("Description is required."); return; }
        setDisabled('disabled');
        try {
            const res = await axios.post(CONST.ADD_MAINTENANCE, {
                asset_item_id: maintAssetId, maintenance_type: maintType, description: maintDesc,
                cost: maintCost || null, vendor: maintVendor, start_date: maintStartDate ? moment(maintStartDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                performed_by: userId
            }, { headers: { Authorization: `Bearer ${isToken}` } });
            if (res.data.status === 'success') { toast.success(res.data.message); setShowMaint(false); setMaintDesc(''); setMaintCost(''); setMaintVendor(''); fetchData(); }
            else toast.error(res.data.message);
        } catch (e) { toast.error("Something went wrong."); }
        setDisabled('');
    };

    const handleSearch = () => { setSearchParam({ asset_tag: srchTag, asset_type_id: srchType, brand_name: srchBrand, model_name: srchModel, serial_number: srchSerial, status: srchStatus, condition: srchCondition, holder_name: srchHolder }); setActivePage(1); };
    const clearSearch = () => { setSrchTag(''); setSrchType(''); setSrchBrand(''); setSrchModel(''); setSrchSerial(''); setSrchStatus(''); setSrchCondition(''); setSrchHolder(''); setSearchParam({}); setActivePage(1); };
    const handleSort = (col, dir) => { setActivePage(1); setDataSort({ order: dir, order_by: col.sortField }); };
    const handlePageChange = (page) => setActivePage(parseInt(page));

    const handleExport = async () => {
        setFullLoading(true);
        try {
            const res = await axios.get(CONST.EXPORT_ASSET_REGISTER, { headers: { Authorization: `Bearer ${isToken}` }, responseType: 'blob' });
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement("a"); link.href = URL.createObjectURL(blob);
            link.download = `asset_register_${moment().format('YYYY-MM-DD')}.xlsx`; link.click();
            toast.success("Exported successfully");
        } catch (e) { toast.error("Export failed"); }
        setFullLoading(false);
    };

    const handleBulkVerify = async () => {
        if (selectedRows.length === 0) { toast.error("Select assets to verify."); return; }
        setFullLoading(true);
        try {
            const res = await axios.post(CONST.BULK_VERIFY_ASSET, { ids: selectedRows.map(r => r.id), user_id: userId }, { headers: { Authorization: `Bearer ${isToken}` } });
            if (res.data.status === 'success') { toast.success(res.data.message); setSelectedRows([]); fetchData(); }
        } catch (e) { toast.error("Verify failed"); }
        setFullLoading(false);
    };

    const statusColors = { available: '#059669', allocated: '#1e40af', maintenance: '#c2410c', disposed: '#64748b', lost: '#dc2626' };
    const conditionColors = { new: '#059669', good: '#1167e8', fair: '#b45309', damaged: '#dc2626', disposed: '#64748b' };

    const columns = [
        { name: "Tag", selector: r => r.asset_tag, sortable: true, sortField: "asset_tag", cell: r => <span style={{ fontWeight: 700, color: '#1167e8', fontSize: '0.78rem' }}>{r.asset_tag}</span> },
        { name: "Type", cell: r => r.assetType?.name || '-' },
        { name: "Brand", cell: r => r.brand?.name || '-' },
        { name: "Model", cell: r => r.model_name || '-', wrap: true },
        { name: "Serial", cell: r => r.serial_number || '-' },
        { name: "Status", cell: r => <span style={{ background: statusColors[r.status] + '20', color: statusColors[r.status], padding: '2px 8px', borderRadius: 12, fontSize: '0.7rem', fontWeight: 600 }}>{r.status}</span> },
        { name: "Condition", cell: r => <span style={{ color: conditionColors[r.condition], fontWeight: 600, fontSize: '0.78rem' }}>{r.condition}</span> },
        { name: "Holder", cell: r => r.currentHolder ? `${r.currentHolder.first_name} ${r.currentHolder.last_name}` : '-' },
        { name: "Warranty", cell: r => r.warranty_end_date ? moment(r.warranty_end_date).format('DD-MM-YYYY') : '-' },
        {
            name: "Action", width: "120px",
            cell: r => (
                <div style={{ display: 'flex', gap: '4px' }}>
                    <button className="btn btn-link btn-sm p-0" onClick={() => handleShow('Edit', r)} title="Edit">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    </button>
                    {r.status === 'allocated' && (
                        <button className="btn btn-link btn-sm p-0 text-warning" onClick={() => { setReturnAssetId(r.id); setReturnCondition(r.condition || 'good'); setShowReturn(true); }} title="Return">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
                        </button>
                    )}
                    {r.status !== 'disposed' && r.status !== 'maintenance' && (
                        <button className="btn btn-link btn-sm p-0 text-info" onClick={() => { setMaintAssetId(r.id); setShowMaint(true); }} title="Maintenance">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
                        </button>
                    )}
                </div>
            ),
        },
    ];

    const CustomLoader = () => <div style={{ padding: "24px" }}><DivLoader color="primary" /></div>;

    const BootyPagination = ({ rowCount, onChangePage, currentPage }) => {
        const pages = Math.ceil(rowCount / perPage);
        const pageItems = []; for (let i = 1; i <= pages; i++) pageItems.push(i);
        const paginationText = rowCount > 0 ? `Page: ${currentPage}, Showing ${(currentPage-1)*perPage+1} to ${Math.min(perPage*currentPage,rowCount)} of ${rowCount}` : 'No entries';
        return (
            <div className='row card-footer'>
                <div className='col-md-4 align-self-center'>{paginationText}</div>
                <div className='col-md-8 text-align-right'>
                    <ul className="pagination text-align-right float-right">
                        <li className="page-item"><button className="page-link" onClick={() => onChangePage(currentPage-1)} disabled={currentPage===1}>«</button></li>
                        {pageItems.map((p,i) => p<=maxPageLimit && p>minPageLimit ? <li key={i} className={`page-item ${currentPage===p?"active":""}`}><button className={`page-link ${currentPage===p?"active":""}`} onClick={() => onChangePage(p)}>{p}</button></li> : null)}
                        <li className="page-item"><button className="page-link" onClick={() => onChangePage(currentPage+1)} disabled={currentPage===pages||pages===0}>»</button></li>
                    </ul>
                </div>
            </div>
        );
    };

    return (
        <>
            <Loading loading={fullLoading} background="rgba(0,0,0,0.5)" loaderColor="#fff" />
            <div className="page-header d-print-none">
                <div className="container-xl">
                    <div className="row g-2 align-items-center">
                        <div className="col">
                            <div className="page-pretitle">Assets</div>
                            <h2 className="page-title">Asset Register</h2>
                        </div>
                        <div className="col-12 col-md-auto ms-auto d-print-none">
                            <div className="btn-list">
                                <button className="btn btn-outline-success" onClick={handleExport}><FiDownload size={16} />&nbsp;Export Excel</button>&nbsp;
                                {selectedRows.length > 0 && (
                                    <button className="btn btn-outline-primary" onClick={handleBulkVerify}><FiCheckCircle size={16} />&nbsp;Verify ({selectedRows.length})</button>
                                )}&nbsp;
                                <button className="btn btn-primary" onClick={() => handleShow('Add', null)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-plus" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                                    &nbsp;Add Asset
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-body">
                <div className="container-xl">
                    <div className="row row-cards">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header"><h3 className="card-title">Listing</h3></div>
                                <div className="card-body border-bottom py-3">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group mb-3"><label className="form-label">Asset Tag</label>
                                                <input type="text" className="form-control" placeholder="e.g. LAP-001" value={srchTag} onChange={e => setSrchTag(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group mb-3"><label className="form-label">Type</label>
                                                <select className="form-select form-control" value={srchType} onChange={e => setSrchType(e.target.value)}>
                                                    <option value="">All</option>
                                                    {assetTypes.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group mb-3"><label className="form-label">Brand</label>
                                                <input type="text" className="form-control" placeholder="Search brand" value={srchBrand} onChange={e => setSrchBrand(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group mb-3"><label className="form-label">Model</label>
                                                <input type="text" className="form-control" placeholder="Search model" value={srchModel} onChange={e => setSrchModel(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group mb-3"><label className="form-label">Serial Number</label>
                                                <input type="text" className="form-control" placeholder="Search serial" value={srchSerial} onChange={e => setSrchSerial(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group mb-3"><label className="form-label">Status</label>
                                                <select className="form-select form-control" value={srchStatus} onChange={e => setSrchStatus(e.target.value)}>
                                                    <option value="">All</option>
                                                    <option value="available">Available</option>
                                                    <option value="allocated">Allocated</option>
                                                    <option value="maintenance">Maintenance</option>
                                                    <option value="disposed">Disposed</option>
                                                    <option value="lost">Lost</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group mb-3"><label className="form-label">Condition</label>
                                                <select className="form-select form-control" value={srchCondition} onChange={e => setSrchCondition(e.target.value)}>
                                                    <option value="">All</option>
                                                    <option value="new">New</option>
                                                    <option value="good">Good</option>
                                                    <option value="fair">Fair</option>
                                                    <option value="damaged">Damaged</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group mb-3"><label className="form-label">Holder</label>
                                                <input type="text" className="form-control" placeholder="Employee name" value={srchHolder} onChange={e => setSrchHolder(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group mb-3"><label className="form-label">&nbsp;</label>
                                                <div>
                                                    <button type="button" className="btn btn-blue d-none d-sm-inline-block mr-2" onClick={handleSearch}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-search" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><circle cx="10" cy="10" r="7"/><line x1="21" y1="21" x2="15" y2="15"/></svg>Search
                                                    </button>&nbsp;
                                                    <button type="button" className="btn btn-outline-primary" onClick={clearSearch}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>Clear
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        progressPending={loading}
                                        progressComponent={<CustomLoader />}
                                        pagination="true"
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        onChangePage={handlePageChange}
                                        paginationPerPage={perPage}
                                        paginationComponent={BootyPagination}
                                        sortServer
                                        onSort={handleSort}
                                        selectableRows
                                        onSelectedRowsChange={({ selectedRows }) => setSelectedRows(selectedRows)}
                                    />
                                </div>
                                <div className="card-footer d-flex align-items-center">
                                    <p className="m-0 text-muted">Showing <span>{totalRows}</span> entries</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/Edit Modal */}
            <Modal size="lg" show={show} onHide={handleClose}>
                <Modal.Header closeButton style={{ borderBottom: 'none' }}>
                    <Modal.Title>{action} Asset Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label required">Asset Type</label>
                                    <Select
                                        placeholder="Select Type"
                                        options={assetTypes.map(t => ({ value: t.id, label: t.name }))}
                                        value={assetTypeId ? assetTypes.filter(t => t.id == assetTypeId).map(t => ({ value: t.id, label: t.name }))[0] : null}
                                        onChange={opt => handleTypeChange(opt ? opt.value : '')}
                                        isClearable
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label">Asset Tag</label>
                                    <input type="text" className="form-control" value={assetTag} readOnly style={{ background: '#f1f5f9' }} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label">Brand</label>
                                    <Select
                                        placeholder="Select Brand"
                                        options={brands.map(b => ({ value: b.id, label: b.name }))}
                                        value={brandId ? brands.filter(b => b.id == brandId).map(b => ({ value: b.id, label: b.name }))[0] : null}
                                        onChange={opt => setBrandId(opt ? opt.value : '')}
                                        isClearable
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label">Model Name</label>
                                    <input type="text" className="form-control" placeholder="e.g. Dell Latitude 5540" value={modelName} onChange={e => setModelName(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label">Serial Number</label>
                                    <input type="text" className="form-control" placeholder="Manufacturer serial" value={serialNumber} onChange={e => setSerialNumber(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label">Condition</label>
                                    <select className="form-select form-control" value={condition} onChange={e => setCondition(e.target.value)}>
                                        <option value="new">New</option>
                                        <option value="good">Good</option>
                                        <option value="fair">Fair</option>
                                        <option value="damaged">Damaged</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group mb-3">
                                    <label className="form-label">Purchase Date</label>
                                    <DatePicker value={purchaseDate} dateFormat="DD-MM-YYYY" timeFormat="" onChange={val => setPurchaseDate(val)} />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group mb-3">
                                    <label className="form-label">Cost (INR)</label>
                                    <input type="number" className="form-control" placeholder="0.00" value={purchaseCost} onChange={e => setPurchaseCost(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group mb-3">
                                    <label className="form-label">Warranty Expiry</label>
                                    <DatePicker value={warrantyEndDate} dateFormat="DD-MM-YYYY" timeFormat="" onChange={val => setWarrantyEndDate(val)} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label">Location</label>
                                    <input type="text" className="form-control" placeholder="e.g. Office Floor 2, Desk 15" value={location} onChange={e => setLocation(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label">Classification</label>
                                    <select className="form-select form-control" value={classification} onChange={e => setClassification(e.target.value)}>
                                        <option value="general">General</option>
                                        <option value="confidential">Confidential</option>
                                        <option value="critical">Critical</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group mb-3">
                                    <label className="form-label">Notes</label>
                                    <textarea className="form-control" rows="2" value={notes} onChange={e => setNotes(e.target.value)} />
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                    <Button variant="primary" onClick={handleSubmit} disabled={disabled}>{disabled ? 'Submitting...' : 'Submit'}</Button>
                </Modal.Footer>
            </Modal>

            {/* Return Modal */}
            <Modal show={showReturn} onHide={() => setShowReturn(false)}>
                <Modal.Header closeButton style={{ borderBottom: 'none' }}>
                    <Modal.Title>Return Asset</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group mb-3">
                        <label className="form-label required">Condition at Return</label>
                        <Select
                            options={[{ value: 'new', label: 'New' }, { value: 'good', label: 'Good' }, { value: 'fair', label: 'Fair' }, { value: 'damaged', label: 'Damaged' }]}
                            value={{ value: returnCondition, label: returnCondition.charAt(0).toUpperCase() + returnCondition.slice(1) }}
                            onChange={opt => setReturnCondition(opt.value)}
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label className="form-label">Notes</label>
                        <textarea className="form-control" rows="2" placeholder="Any remarks" value={returnNotes} onChange={e => setReturnNotes(e.target.value)} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowReturn(false)}>Cancel</Button>
                    <Button variant="warning" onClick={handleReturn} disabled={disabled}>{disabled ? 'Processing...' : 'Confirm Return'}</Button>
                </Modal.Footer>
            </Modal>

            {/* Maintenance Modal */}
            <Modal show={showMaint} onHide={() => setShowMaint(false)}>
                <Modal.Header closeButton style={{ borderBottom: 'none' }}>
                    <Modal.Title>Schedule Maintenance</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group mb-3">
                        <label className="form-label required">Type</label>
                        <Select
                            options={[{ value: 'repair', label: 'Repair' }, { value: 'upgrade', label: 'Upgrade' }, { value: 'cleaning', label: 'Cleaning' }, { value: 'inspection', label: 'Inspection' }]}
                            value={{ value: maintType, label: maintType.charAt(0).toUpperCase() + maintType.slice(1) }}
                            onChange={opt => setMaintType(opt.value)}
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label className="form-label required">Description</label>
                        <textarea className="form-control" rows="2" placeholder="What needs to be done" value={maintDesc} onChange={e => setMaintDesc(e.target.value)} />
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label className="form-label">Cost (INR)</label>
                                <input type="number" className="form-control" value={maintCost} onChange={e => setMaintCost(e.target.value)} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label className="form-label">Vendor</label>
                                <input type="text" className="form-control" placeholder="Service center" value={maintVendor} onChange={e => setMaintVendor(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="form-group mb-3">
                        <label className="form-label">Start Date</label>
                        <DatePicker value={maintStartDate} dateFormat="DD-MM-YYYY" timeFormat="" onChange={val => setMaintStartDate(val)} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowMaint(false)}>Cancel</Button>
                    <Button variant="info" onClick={handleMaintSubmit} disabled={disabled}>{disabled ? 'Processing...' : 'Schedule'}</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AssetRegister;
